// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "./Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "./Stack.res.js";
import * as Title from "../typography/Title.res.js";
import * as React from "react";
import * as Inline from "./Inline.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as Illustration from "../images-and-icons/Illustration.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let make = React.memo(props => {
  let children = props.children;
  let text = props.text;
  let newrecord = {
    ...{
      className: "alignItems-x6s0dn4 alignSelf-xamitd3 display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf justifyContent-xl56j7k marginTop-x1230xj6 paddingBottom-xrygks2 paddingTop-x1skx261",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/EmptyState.res.js:15"
    }
  };
  return JsxRuntime.jsxs("div", (newrecord.children = [JsxRuntime.jsx(Illustration.make, {
    element: props.illustration
  }), JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Title.make, {
        children: props.title,
        level: 2,
        align: "center"
      }),
      spaceTop: "xsmall",
      spaceBottom: "small"
    }), text !== undefined ? JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: text,
        align: "center",
        variation: "normal"
      }),
      spaceX: "xhuge"
    }) : null, children !== undefined ? JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Inline.make, {
        children: children,
        align: "center"
      }),
      spaceX: "xhuge",
      spaceY: "large"
    }) : null]
  })], newrecord));
});
let error = JsxRuntime.jsx(make, {
  illustration: Illustration.error,
  title: I18n.t("Loading issue"),
  text: I18n.t("Please try refreshing the page.")
});
export { make, error };
/* styles Not a pure module */